import React from "react";
import "../Style/privacyPolicy.css";
const PrivacyPolicyBanner = () => {
  return (
    <div className="flex justify-center items-center text-white z-50 privacy-banner  pt-[132px] pb-[85px]">
      <h1 className=" text-white text-[28px] lg:text-[40px] font-semibold leading-[97px]">
        Privacy Policy
      </h1>
    </div>
  );
};

export default PrivacyPolicyBanner;
